import _ from 'lodash';
import React from 'react';
import {
  useParams,
} from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import axios from 'axios';
import Header from '../layout/Header.jsx';
import { useAsyncResource } from '../../../commons/hooks/useAsyncResource';
import { Form, Formik } from 'formik';
import FormGroup from '~/commons/components/FormGroup.jsx';
import { env } from '~/commons/config';
import { qualityEnum } from '../../const.js';
import ListRecords from '../../../admin/components/forms/stocks/ListRecords.jsx';
import { useAlert } from '../../../commons/components/alert/index.jsx';

const TabBasic = ({ }) => {
  const roles = _.get(env, 'user.roles');
  return (
    <>
      <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">BASIC</h6>
      <div className="row">
        <div className="col">
          <FormGroup name="itemCode" disabled />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormGroup name="serialNo" disabled />
        </div>
        <div className="col">
          <FormGroup name="orgId" label="Organization ID (Comma separated)" disabled />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormGroup name="status" as="select" disabled={_.isEqual(roles, ['customer'])}>
            <option value=""> - </option>
            {(env?.status?.stocks || []).map((v) => (
              <option value={v} key={v}>
                {_.startCase(v)}
              </option>
            ))}
          </FormGroup>
        </div>
        <div className="col">
          {!_.isEqual(roles, ['customer']) && <FormGroup name="quality" as="select">
            <option value=""> - </option>
            {_.map(qualityEnum, x => (
              <option key={x} value={x}>{x}</option>
            ))}
          </FormGroup>}
        </div>
      </div>
      <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">DESIGN</h6>
      <div className="row">
        <div className="col">
          <FormGroup label="Design" name="design.design" as="display" />
        </div>
        <div className="col">
          <FormGroup label="Collection" name="design.coll.name" as="display" />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormGroup label="Brand" name="design.brand" as="display" />
        </div>
        <div className="col">
          <FormGroup name="color" disabled />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormGroup name="shape" disabled />
        </div>
        <div className="col">
          <FormGroup name="style" disabled />
        </div>
      </div>
      <FormGroup
        name="description"
        as="summernote"
        injectValue
        disabled
        options={{
          styleTags: ['p', 'h2', 'h3', 'h4', 'h5', 'h6'],
          toolbar: [
            ['style', ['style']],
            ['font', ['bold', 'italic', 'underline', 'strikethrough', 'clear']],
            ['view', ['codeview', 'undo', 'redo']],
            ['para', ['paragraph']],
          ],
        }}
      />
      <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">SALES</h6>
      <div className="row">
        <div className="col">
          <FormGroup name="prices.retailPrice" label="Retail Price" type="number" min="0" disabled />
        </div>
        <div className="col">
          <FormGroup name="prices.currency" as="select" disabled>
            <option value=""> - </option>
            {env.currencies.map(({ code, symbol }) => (
              <option value={code} key={code}>
                {`${_.startCase(code)} - ${symbol}`}
              </option>
            ))}
          </FormGroup>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormGroup name="location" label="Location" disabled />
        </div>
      </div>
      <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">DIMENSION</h6>
      <div className="row">
        <div className="col">
          <FormGroup name="sqm" type="number" disabled />
        </div>
        <div className="col">
          <FormGroup name="size" disabled />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormGroup name="width" type="number" disabled />
        </div>
        <div className="col">
          <FormGroup name="length" type="number" disabled />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormGroup name="quantity" type="number" disabled />
        </div>
        <div className="col">
          <FormGroup name="quantityUnit" as="select" disabled>
            {env?.unitOfMeasure.map((v) => (
              <option value={v} key={v}>
                {_.startCase(v)}
              </option>
            ))}
          </FormGroup>
        </div>
      </div>
      <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">ADDITIONAL</h6>
      <div className="row">
        <div className="col">
          <FormGroup name="category" disabled />
        </div>
        <div className="col">
          <FormGroup name="yarnContent" label="Color / Content (Comma separated)" disabled />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormGroup name="remarks" disabled />
        </div>
      </div>
      {!_.isEqual(roles, ['customer']) && <div className="row">
        <div className="col">
          <FormGroup name="internalRemarks" as="textarea" disabled style={{ height: '100px' }} />
        </div>
      </div>}
      <FormGroup
        name="photos"
        as="slider"
        api="/api/core/stocks/files"
        label="Photos"
        gridClassName="col-3 my-3"
        slideClassName="file-slide-contain square"
        disabled />
    </>
  );
}

const PageStock = () => {

  const roles = _.get(env, 'user.roles');
  const { _id } = useParams();
  const showAlert = useAlert();

  const breadcrumb = [
    { to: '/portal/stocks', children: 'Stocks' },
  ];

  const { resource: { data: doc = {} } = {} } = useAsyncResource(async () => {
    return axios.get(`/api/core/stocks/${_id}`);
  }, [_id]);

  return (
    <div className="py-4">
      <Header breadcrumb={breadcrumb}>{_.isEqual(roles, ['customer']) ? 'View' : 'Edit'}</Header>
      <Formik
        key={doc._id}
        initialValues={{ ...doc }}
        onSubmit={async (values) => {
          try {
            const res = await axios.patch(`/api/core/stocks/${_id}`, {
              status: values.status,
              quality: values.quality,
            });

            if (res.status === 200) {
              showAlert('success', 'Saved succesfully', 2000);
            } else {
              showAlert('danger', 'Unknown error', 2000);
            }

          } catch (e) {
            if (e.response?.status === 400) {
              showAlert('danger', e.response.data, 2000);
            } else {
              showAlert('danger', e, 2000);
            }
          }
        }}
      >
        <Form>
          {_.isEqual(roles, ['customer']) ? (
            <>
              <TabBasic />
            </>
          ) : (
            <>
              <button className='btn btn-primary mb-3'>Save</button>
              <Tabs defaultActiveKey="basic" unmountOnExit>
                <Tab eventKey="basic" title="Basic">
                  <TabBasic />
                </Tab>
                <Tab eventKey="records" title="OnHold Record">
                  <ListRecords _id={doc._id} />
                </Tab>
              </Tabs>
            </>
          )}
        </Form>
      </Formik>
    </div>
  );
};

export default PageStock;
